/**
 * @description sign up页面内容注册
 */


/************************************** Module ***********************************************/
import angular from 'angular';

import { PageModule } from "@modules/main/anonymous-page.module";

import { mainModule } from "@modules/main/main.module";

import { cartModule } from "@modules/cart/cart.module";

import { LoadingModule } from "@directives/qp-loading/qp-loading.module";

import { RegistPartnerVerifyModule } from "@directives/regist-partner-verify/regist-partner-verify.module"

import { module_name as recaptcha } from "@modules/common/tool/recaptcha/recaptcha.module";

import { module_name as thirdAuthLogin } from "@pages/partner/social-login/index.module";

import { name as storage } from "@modules/storage/storage.module";

import 'qp-msg-prompt';

/************************************** 样式文件(加载顺序不可改变) ***********************************************/
import 'sweetalert2/dist/sweetalert2.css';

import './style/regist.less';

import '../../../../directives/regist-partner-verify/regist-partner-verify.less';

/************************************** Provider ***********************************************/

import { MessageConfig } from "@directives/form-message/MessageConfig";

/************************************** Directive ***********************************************/

import { FormItemDirective } from "@directives/form-item/form-item.directive";

import { FormMessageDirective } from "@directives/form-message/form-message.directive";

import { TemplateCompileDirective } from "@directives/template-compile/Template-compile.directive";

import { PostValidationDirective } from "@directives/post-validation/post-validation.directive";


/************************************** Service ***********************************************/
import { RuntimeContext } from "@modules/main/runtime-context.service";

import { RecaptchaHelper } from '@modules/common/tool/recaptcha/recaptcha-helper';

import { RegistObjectTreeService } from '@pages/partner/regist/regist-object-tree.service';

/*************************************** Template ************************************************/


/************************************** Controller ***********************************************/
import { RegistController } from '@pages/partner/regist/regist.controller';
import { privacyPolicyRegister } from '@directives/privacy-policy/privacy-policy.register';



/************************************** 内容注册 ***********************************************/

let registModule = angular.module("qpmn-regist", [PageModule.name, mainModule.name, cartModule.name, LoadingModule.name, RegistPartnerVerifyModule.name, recaptcha, storage, thirdAuthLogin])
    .controller({
        registController: RegistController
    })
    .service({
        $objectTree: RegistObjectTreeService
    })
    .directive({
        formItem: FormItemDirective,
        formMessage: FormMessageDirective,
        templateCompile: TemplateCompileDirective,
        postValidation: PostValidationDirective
    })
    .constant("pageContext", {
        rootPath: "../../"
    })
    .provider({
        messageConfig: MessageConfig
    })
    .config(["messageConfigProvider", (messageConfigProvider: MessageConfig) => {
        // TODO
        let typeMsg = [
            // TODO password提示文本待优化
            { vType: "pattern", message: "Please enter the correct email address" },
            { vType: "email", message: "Please enter the correct email address" },
            { vType: "minlength", message: "Enter a minimum of 12 characters" },
            { vType: "account", message: "Username or password not correct!" },
        ]
        typeMsg.forEach((item) => {
            messageConfigProvider.setErrorMessage(item.vType, item.message);
        })
    }])

privacyPolicyRegister.regist(registModule);

// google recaptcha
RecaptchaHelper.loadGrecaptchaScriptLabel();
